import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      © 2022 François Chevalier | Tous droits réservés
    </div>
  );
};

export default Footer;
